'use strict';

window.TES = window.TES || {};


window.TES.User = function(cookie, user) {
    this._authCookie = cookie;
    if (user) {
        this.roles = user.roles;
    }
};

window.TES.User.prototype = {

    _authCookie: null,
    roles: [],

    isAuthenticated: function () {
        return !!this._authCookie;
    },

    getId: function () {
        return this._authCookie;
    },

    hasRole: function (role) {
        return (this.roles.indexOf(role) > -1);
    }
};
